import { Component, OnInit, Input } from '@angular/core';
import { _MSGTYPES } from '../../constant/msgType';

/* 传入消息类型，获取消息类型的图标 */

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-msg-icon',
  styles: [':host {display:flex; width:24px;}'],
  template: `
    <ng-container *ngFor="let item of msgList">
      <img *ngIf="item.type == msgType" [src]="item.icon" alt="" style="width:100%;" />
    </ng-container>
  `,
})
export class IccMsgIconComponent implements OnInit {
  constructor() {}
  // 消息类型
  @Input() msgType: any;
  // 是否上行，默认false
  @Input() isMO: boolean;

  // 消息列表
  msgList: any;

  ngOnInit() {
    if (undefined !== this.msgType) {
      this.msgType = Number(this.msgType);
    }
    this.msgList = _MSGTYPES.getMsgList(!!this.isMO);
  }
}
